import { VaroCategories } from 'shared/analytics/types/categories';

export const VaroPressableNames = {
  DCF: {
    DCF_ADD_MONEY_NEW_CARD: 'dcf_add_money_new_card',
    DCF_ADD_MONEY_SAVED_CARD: 'dcf_add_money_saved_card',
  },
  INCENTIVE: {
    JOIN_INCENTIVE: 'join_incentive',
    INCENTIVE_HOW_IT_WORKS: 'incentive_how_it_works',
    START_INCENTIVE_PREREQUISITE: 'start_incentive_prerequisite',
    SKIP_INCENTIVE: 'skip_incentive',
    INCENTIVE_OPTED_IN_CONTINUE: 'incentive_opted_in_continue',
    VIEW_INCENTIVE_PREREQUISITE_PRODUCT: 'view_incentive_prerequisite_product',
    VIEW_INCENTIVE_FROM_ACCOUNT_CARD: 'view_incentive_from_account_card',
  },
} as const satisfies Partial<
  Record<keyof typeof VaroCategories, Record<string, string>>
>;

export type VaroPressableName = {
  [
    K in keyof typeof VaroPressableNames
  ]: (typeof VaroPressableNames)[K][keyof (typeof VaroPressableNames)[K]];
}[keyof typeof VaroPressableNames];
